import {Component, Output, EventEmitter, Input, OnInit, ViewChild, Inject} from '@angular/core';
import {InputSearchComponent} from "../input-search/input-search.component";
import {filter, map} from "rxjs";
import {AuthState, OktaAuth} from "@okta/okta-auth-js";
import {BusService} from "../../../@bus/bus.service";
import {OKTA_AUTH, OktaAuthStateService} from "@okta/okta-angular";

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {
  @ViewChild(InputSearchComponent) inputSearchComponent?: InputSearchComponent;

  @Input() tipoFiltro: string = '';
  @Input() selectedProyecto: string = 'all';
  @Input() tipoDocumento: string = 'all';
  @Input() tipoEstado: string = 'all';
  @Input() selectedDateRange: any;
  @Input() portal: string = '';

  @Output() onApplyFilters: EventEmitter<any> = new EventEmitter();
  @Output() onClearFilters: EventEmitter<void> = new EventEmitter();
  @Output() dateRangeChange: EventEmitter<any> = new EventEmitter();
  @Output() tipoDocumentoChange: EventEmitter<string> = new EventEmitter();
  @Output() tipoEstadoChange: EventEmitter<string> = new EventEmitter();
  @Output() proyectoChange: EventEmitter<string> = new EventEmitter();
  @Output() searchChange: EventEmitter<string> = new EventEmitter();

  isCalendarVisible: boolean = false;
  labelProyectos: string = $localize`Servicio: `;
  labelBuscar: string = $localize`Buscar: `;
  labelFechas: string = $localize`Fechas: `;
  labelTipoDocumento: string = $localize`Tipo de Documento: `;
  labelLimpiar: string = $localize`Limpiar Filtros`;
  labelEstado: string = $localize`Consultas:`;
  isMapfre: boolean = false;

  proyectos: any[] = [];

  constructor(private bus: BusService) {}

  ngOnInit(): void {
    this.updateProyectos();
    if (this.bus.isColectivoMapfre()){
      this.isMapfre = true;
    }
  }

  toggleCalendar(): void {
    this.isCalendarVisible = !this.isCalendarVisible;
  }

  clearFilters(): void {
    this.onClearFilters.emit();
  }

  onDateRangeChange(event: any): void {
    this.dateRangeChange.emit(event);
  }

  onTipoDocumentoChange(event: string): void {
    this.tipoDocumentoChange.emit(event);
  }

  onTipoEstadoChange(event: string): void {
    this.tipoEstadoChange.emit(event);
  }

  onProyectoChange(event: string): void {
    this.proyectoChange.emit(event);
  }

  onSearch(event: string): void {
    this.searchChange.emit(event);
  }

  updateProyectos(): void {
    this.proyectos = [
      { id: 486, nombre: 'Experto Abogado' },
      { id: 87, nombre: 'Asesor Fiscal' },
    ];
  }
}
